import React from 'react'
import { CrossFadeLogos, Text, Icon } from '@rebrandly/styleguide'

import './LovedByLogos.css'

const LovedByLogos = () => {
  return (
    <div className='LovedByLogos'>
      <div className='container'>
        <div className='flex m-b-24 text-center'>
          <Text size='regular'>Rebrandly is loved <Icon name='ic-favorite' size='xsmall' className='m-r-4 m-l-4 m-t-2'/> by the world’s smartest companies</Text>
        </div>
        <div className='LovedByLogos__logos-container'>
          <CrossFadeLogos columnsNumber={6} shuffle/>
        </div>
      </div>
    </div>
  )
}

export default LovedByLogos
